export enum QueryParameters {
  PageIndex = 'pageIndex',
  SortById = 'sortById',
  SortByDesc = 'sortByDesc',
  SearchTerm = 'searchTerm',
  Filter = 'filter'
}
